import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, Modal, notification } from 'antd'
import moment from 'moment'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { traceRoute } from '../../../layouts/layoutSlice'
import { DateTimeFormatMessageSimple } from '../../../models/datetime'
import { NotificationCenterParams } from '../../../services/notificationCenter'
import { ThemeContext } from '../../../theme/ThemeContext'
import { NotificationCenterColumns } from './column'
import {
  getDeleteSubmit,
  getExpireSubmit,
  getNotificationCenterList,
} from './notificationCenterSlice'
import { NotifictionModal } from './notifictionModal'
import { PostponeModalodal } from './postponeModal'
import { NotificationCenterQuery } from './query'

export const NotificationCenter = (props: { tabKey?: any }): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [isEditModalVisible, setIsEditModalVisible] = useState(false)

  const [isPostponeModalVisible, setIsPostponeModalVisible] = useState(false)

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any>()

  const [id, setId] = useState<any>()

  const [adviseState, setAdviseState] = useState() //延期 到期状态

  const [queries, setQueries] = useState<NotificationCenterParams>({
    current: 1,
    size: 10,
    startTime: moment().startOf('month').format(DateTimeFormatMessageSimple),
    endTime: moment().endOf('month').format(DateTimeFormatMessageSimple),
  })

  const getDataList = () => {
    dispatch(
      getNotificationCenterList({
        ...queries,
        flag: queries?.flag ? queries?.flag : 1,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
  }

  useEffect(() => {
    if (props?.tabKey == '0') {
      if (queries) getDataList()
    }
  }, [props?.tabKey, queries])

  return (
    <Col
      style={{
        height: 'calc(100% - 30px)',
        overflow: 'hidden',
        position: 'relative',
        marginTop: 10,
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Col
        style={{
          flex: 1,
          backgroundColor: theme.pn,
          borderRadius: 10,
          padding: '10px 15px 0 15px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <NotificationCenterQuery
          onValueChange={(v) => {
            setQueries({ ...v })
          }}
          add={() => {
            setId('')
            setIsEditModalVisible(true)
          }}
        />

        <EditableList
          bordered
          page={{
            items: data,
            current: queries.current || 1,
            size: queries.size || 10,
            total: total,
          }}
          columns={NotificationCenterColumns(
            (text, t) => {
              setAdviseState(t?.adviseState)
              if (text === 'postpone') {
                //延期
                setIsPostponeModalVisible(true)
                setId(t?.messageReadId)
              } else if (text == 'expire') {
                //到期
                Modal.confirm({
                  content: '请确认是否进行一键到期操作？',
                  onOk: () => {
                    dispatch(getExpireSubmit({ id: t?.messageReadId }))
                      .then(unwrapResult)
                      .then((v: any) => {
                        notification.success({
                          message: v,
                        })
                        getDataList()
                      })
                  },
                  onCancel: () => {
                    getDataList()
                  },
                })
              } else if (text === 'edit') {
                setId(t?.messageId)
                setIsEditModalVisible(true)
              } else if (text === 'delete') {
                Modal.confirm({
                  content: '请确认是否删除？',
                  onOk: async () => {
                    dispatch(
                      getDeleteSubmit({
                        messageReadId: t?.messageReadId,
                        messageId: t?.messageId,
                      })
                    )
                      .then(unwrapResult)
                      .then((v: any) => {
                        notification.success({
                          message: '删除成功',
                        })
                        getDataList()
                      })
                  },
                  onCancel: () => {
                    getDataList()
                  },
                })
              }
            },
            (queries.size || 10) * ((queries.current || 1) - 1),
            queries.flag
          )}
          onChangePage={(current: any, size: any) => {
            setQueries({
              ...queries,
              current,
              size,
            })
          }}
          onRow={(r) => ({
            onDoubleClick: () => {
              setId(r.id)
            },
          })}
        />
      </Col>
      <NotifictionModal
        isModalVisible={isEditModalVisible}
        messageId={id}
        onCancel={() => {
          setIsEditModalVisible(false)
          setId('')
          getDataList()
        }}
        onOk={() => {
          setIsEditModalVisible(false)
          setId('')
          getDataList()
        }}
      />
      <PostponeModalodal
        isModalVisible={isPostponeModalVisible}
        id={id}
        adviseState={adviseState}
        onCancel={() => {
          setIsPostponeModalVisible(false)
          setId('')
          getDataList()
        }}
        onOk={() => {
          setIsPostponeModalVisible(false)
          setId('')
          getDataList()
        }}
      />
    </Col>
  )
}
